/**
 * @file use-mobile.js
 * @description Hook para detectar se o dispositivo é mobile (CRA)
 */

import { useState, useEffect } from "react"

const MOBILE_BREAKPOINT = 768

/**
 * Hook para detectar se o dispositivo é mobile
 * @returns {boolean} true se for mobile
 */
export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(false)
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    }
    mql.addEventListener("change", onChange)
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    return () => mql.removeEventListener("change", onChange)
  }, [])

  // Retorna false durante SSR para evitar problemas de hidratação
  if (!isClient) return false

  return isMobile
}

// Alias para compatibilidade
export function useMobile() {
  return useIsMobile()
}
